/*
 * @Description:
 * @Date: 2020-11-03 09:41:19
 */
const getDomain = () => {
  let hostname = window.location.hostname;
  let len = 0;
  if (process.env.NODE_ENV !== 'development') {
    hostname = hostname.split('.');
    len = hostname.length;
    hostname = `${hostname[len - 2]}.${hostname[len - 1]}`;
  }
  return hostname;
};
console.log(process.env.NODE_ENV, '---当前环境');
console.log(getDomain(), '---当前一级域名');
console.log(process.env.VUE_APP_WEBVIEW, '---当前webview域名');

const config = {
  token: 'csoSaaSToken',
  domain: getDomain(),
  webPath: '/html/index.html#',
  webViewUrl: process.env.VUE_APP_WEBVIEW,
  biUrl: process.env.VUE_APP_BI_DOMAIN,
  AMAP_KEY: '9d5f5e16cd8c23b4a284074ce4db8cfc',
  AMAP_API_KEY: 'c11a4f25b573f578f17615961e2ff1ae',
  QQ_MAP_KEY: 'ZXVBZ-4333V-RT3PJ-UQYHY-SIBIQ-BHFTU',
  fileViewUrl: '//cdn.yxvzb.com/WEB/SaaS/file-view/index.html'
};
export default config;
